<template><div class="file-manager">
    <div class="mask"></div>
    <div class="dig" v-dlgdrag>
        <div class="dig_title clearFix">
            <div class="fl"><b class="mark_choose"></b>选择产品</div>
            <Icon class="fr" type="close-round" @click.native="dialogClose"/>
        </div>
		<div class="dig-main clearFix artical-file-dig-main">
			<div class="main-left main-left-table" style="right:0px;padding-right:20px;">
				<div class="tab_content" style="margin-top: 50px;">
					<div ref="tabul" class="artical_tab_ul" v-bar="{preventParentScroll: true,scrollThrottle: 30}">
						<div class="artical_tab_li" style="font-size: 14px;">
							<ul class="main-left-list clearFix" >
								<li v-for="product in products" :key="product.id" class="list-li fl" @click="selectedPrdById(product.id)">
									<div class="list-li-top" :class="{selected: selectedArr.findIndex(v=>v==product.id)>-1}" style="height:60px;position:relative;">
										<img :src="product.thumb" />
										<div class="selectState">
											<span class="iconfont icon-dui" style="font-size: 32px;"></span>
										</div>
									</div>
									<div class="list-li-bottom">
										<template>{{product.name}}</template>
									</div>
								</li>
								<li v-if="! products.length" class="list-li fl" style="color: #f00;width: 150px;">未找到匹配的产品</li>
							</ul>
						</div>
					</div>
				</div>

				<div class="confirm_btn" @click="selectedProduct" style="bottom:25px;">确定({{selectedArr.length}})</div>
				<div class="file_category_box">
					<!--div class="fl">
						<div class="category_box">
							<p @click="boxShow = !boxShow">{{selectedName}}<i :class="arrowTo"></i>
							</p>
							<ul class="box-ul" v-if="boxShow">
								<li @click.prevent="selectedCategory(category.id, category.name)" :class="{active: category_id==category.id}" v-for="category in getCategory" :key="category.id">{{category.name}}</li>
							</ul>
						</div>
					</div-->
					<div class="fr">
						<Input v-model="keyword" placeholder="按产品名称查找">
							<Button @click="searchProduct" slot="append" icon="ios-search"></Button>
						</Input>
					</div>
				</div>
			</div>
		</div>

		<Page @on-change="onPager" :total="total" :page-size="pagesize" size="small" class="pager" />
    </div>
</div></template>

<script>
import jGlobal from '@/global';
import EventBus from '@/common/events';
import Dlgdrag from '@/common/dlgdrag';

export default {
	mixins: [Dlgdrag],
	props: ['attrs', 'category', 'isradio'],
	data (){
		return {
			products: [],
			selectedArr: [],
			keyword: '',
			pagesize: 10,
			total: 0,
			/*category_id: '',
			categories: [],
			selectedName: '全部',*/
		}
	},
	created (){
		// data-source
		this.all_products = [];
		this.loadProduct()
	},
	mounted (){
		$(this.$el).appendTo("body");
		this.$nextTick(() => {
			let winh = $(window).height();
			$(this.$refs.tabul).height(winh - 215)
		})
	},
	methods: {
		loadProduct (params = {}){
			params = Object.assign(params, {status: '1'});
			jGlobal.xhrPost('wxshop/index', params, res => {
				let jsndata = res.data || {};
				this.products = jsndata.source;
				this.all_products = jsndata.source;
				// for 'init-style'
				let pids = [];
				if (! this.attrs.childprop.data_source) {
					pids = this.attrs.childprop.modclick.param.idsvalue
				} else pids = this.attrs.childprop.data_source.value

				if ($.isArray(pids) && pids.length) this.selectedArr = pids;
				if (params.pageid) return false;
				this.pagesize = jsndata.pagesize;
				this.total = jsndata.total
			}, err => console.log(err))
		},
		onPager (pageid){
			let params = {};
            params['pageid'] = pageid;
            params['keyword'] = this.keyword.trim();
            this.loadProduct(params)
		},
		selectedPrdById (id){
			// for 'product-detail'
			let chkedarr = this.selectedArr || [],
			_i = chkedarr.findIndex(v => id == v);
			if (_i < 0) {
				if (this.isradio && chkedarr.length) {
					this.selectedArr.shift()
				}
				this.selectedArr.push(id)
			} else this.selectedArr.splice(_i, 1)
		},
		selectedProduct (){
			let pids = this.selectedArr;
			if (! this.attrs.childprop.data_source) {
				this.attrs.childprop.modclick.param.idsvalue = pids;
				// for 'product-detail'
				if (this.isradio == true) {
					let tmpobj = this.products.find(c => c.id == pids[0]);
					if (tmpobj) this.attrs.childprop.modclick.param.title = tmpobj['name']
				}
			} else {
				this.attrs.childprop.data_source.value = pids;
				// for 'product-detail'
				if (this.isradio == true) {
					let tmpobj = this.products.find(c => c.id == pids[0]);
					if (tmpobj) this.attrs.childprop.data_source.title = tmpobj['name']
				}
			}
			this.dialogClose()
		},
		searchProduct (){
            this.loadProduct({keyword: this.keyword.trim()})
		},
		dialogClose (){
			EventBus.$emit("prdselector_close")
		},
	}
}
</script>

<style scoped>
.ivu-input-group .ivu-input {font-size: 14px;}
/*.popHelper {position: absolute;left: 0;right: 0;top: 0;bottom: 0;background-color: transparent;z-index: 0;}*/
.clearFix:after {content: '';clear: both;width: 0;height: 0;display: block;}
.mask {width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.5);position: fixed;left: 0;top: 0;z-index: 13;}
.dig {width: 880px;height: 100%;background-color: #fff;position: fixed;z-index: 14;min-height: 400px;}
.dig .dig_title {width: 100%;height: 64px;line-height: 60px;padding: 0 15px;font-size: 14px;}
.dig .dig_title .fr {cursor: pointer;}
.dig .dig_title .fr:hover {transform: rotate(720deg);}
.dig .dig_title .fr::before {height: 35px;line-height: 35px;}
.dig .dig_operate {margin: 0 auto;}
.dig .dig-main .main-left {box-sizing: border-box;border-right: 1px solid #e9e9e9;height: 100%;}
.dig_title {border-bottom: 1px solid #dddee1;border-top: 4px solid #2d8cf0;background-color: #fafafa;font-size: 14px;color: #2d8cf0;}
.dig_title .fr {margin-top: 15px;color: #bfbfbf;cursor: pointer;}
.dig-main {position: absolute;left: 0;right: 0;top: 64px;bottom: 0;}
.dig-main .main-left {position: absolute;left: 0;right: 211px;top: 0;bottom: 0;padding-left: 20px;}
.main-left .main_tabs {width: 100%;height: 100%;}
.main-left .main_tabs .tab_content {position: absolute;left: 0;right: 0;bottom: 150px;top: 0;}
.main-left .main_tabs .tab_content .artical_tab_ul {height: 100%;}
.list-li {width: 106px;margin: 0 13px 10px;cursor: pointer;position: relative;}
.list-li:hover .list-li-top {border-color: #2d8cf0;}
.list-li .list-li-top {width: 100%;height: 110px;text-align: center;border: 1px solid #e9e9e9;}
.list-li .list-li-top > img {display: inline;position: relative;border: none;padding: 0;height: 100%;width: auto;max-width: 100%;}
.list-li .list-li-bottom {height: 27px;line-height: 27px;margin: 0 0 3px;text-align: left;text-overflow: ellipsis;width: 106px;overflow: hidden;}
.file_category_box {position: absolute;left: 20px;top: 0;width: 98%;height: 50px;}
.file_category_box .fr {margin-right: 40px;margin-top: 7px;}
.confirm_btn {position: absolute;width: 90%;height: 36px;line-height: 36px;background-color: #2d8cf0;color: #fff;text-align: center;bottom: 5px;left: 50%;transform: translate(-50%);border-radius: 4px;cursor: pointer;}
.pager {position: absolute;width: 90%;text-align: right;height: 32px;bottom: 65px;left: 5%;}
.list-li-top .selectState {display: none;position: absolute;left: 0;right: 0;bottom: 0;top: 0;background-color: rgba(45, 140, 240,.8);border: 2px solid #2d8cf0;text-align: center;line-height: 60px;color: #fff;font-size: 30px;}
.list-li-top.selected .selectState {display: block;}
</style>


// WEBPACK FOOTER //
// product_selector.vue?51e99928